export default "__VITE_ASSET__BjQop5no__"